
import { Component, OnInit, ViewChild, AfterViewInit, EventEmitter, Output, Input } from '@angular/core';
// import { CompanySiteToStoreService } from '../../modules-ll/company-site-to-store/company-site-to-store.service';
import { } from 'googlemaps';

import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
// import { UserSiteConfirmationDialogueComponent } from '../user-site-confirmation-dialogue/user-site-confirmation-dialogue.component';
import { Site } from 'src/app/admin/1.tv/sites/sites.model';
import { SitesService } from 'src/app/admin/1.tv/sites/sites.service';

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss']
})
export class GoogleMapsComponent implements OnInit, AfterViewInit {
  public companyId: string;
  public siteId: String;
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  markers: any[] = [];
  marker: any = null;
  sites$: Observable<Site[]>;
  @Output() InfoWindowConfirmationCompleteEvent: EventEmitter<any> = new EventEmitter();
  @Output() UserSiteConfirmationCompleteEvent: EventEmitter<any> = new EventEmitter();
  @Output() UserCurrentLocationCompleteEvent: EventEmitter<any> = new EventEmitter();
  private photoURL = '../assets/images/admir_icon.png';

  // [src]="'./assets/images/admir_icon.png'"

  constructor(
    private sitesService: SitesService,
    // private companySiteToStoreService: CompanySiteToStoreService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {

    this.InfoWindowConfirmationCompleteEvent.subscribe((e) => {

      if (e.data.detail !== undefined) {
        this.areYouHear(e.data.detail);
      }



    });
    document.addEventListener('build', (e: any) => {

      console.log('build event 2', e);

      console.log('id: ' + e.detail.id);
      console.log('city: ' + e.detail.city);

      const o = Object.assign({});
      o.time = new Date();
      o.data = e;
      this.InfoWindowConfirmationCompleteEvent.emit(o);


    }, false);

    this.companyId = '000001';
    this.siteId = '0000050';

    this.sites$ = this.loadSites();


  }

  ngAfterViewInit(): void {

    const iconSite = {
      url: this.photoURL,
      size: new google.maps.Size(50, 50),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 25),
      scaledSize: new google.maps.Size(50, 50)
    };

    const latlng = new google.maps.LatLng(0, 0);
    const mapProp = {
      center: latlng,
      zoom: 10,
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

    this.sites$.subscribe((sites: Site[]) => {

      sites.forEach((site) => {

        const latlng = new google.maps.LatLng(Number(site.lat), Number(site.lon));
        const marker = this.addMarker(latlng, iconSite, site.address);

        marker.addListener('click', () => {
          // alert(site.id)
          infoWindow.open(this.map, marker);
          this.map.setZoom(8);
          this.map.setCenter(marker.getPosition() as google.maps.LatLng);

        });

        marker.setMap(this.map);

        const infoWindow = new google.maps.InfoWindow();

        const str = `
        <div style="color:blue">
            <b>${site.siteName}</b>
        </div>
        <div style="color:blue">
          ${site.address}
        </div>
        <div style="color:blue">
          ${site.city}
        </div>
        <div style="color:blue">
          ${site.postalCode}
        </div>
        <div style="width:100%; text-align:center background: orange">
          <button onclick="openUserSiteConfirmation(
            '${site.id}',
            '${site.companyId}',
            '${site.siteName}',
            '${site.address}',
            '${site.city}',
            '${site.region}',
            '${site.postalCode}',
            '${site.country}'
            )">Order from here</button>

        </div>

      `;
        infoWindow.setContent(str);

      });

    });

    this.start();

  }

  addMarker(location: any, icon: any, title: any) {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon,
      title
    });
    return marker;
  }

  error = (error: any) => {
    switch (error.code) {
      case 1:
        alert('permission denied');
        break;
      case 2:
        alert('position unavailable');
        break;
      case 3:
        alert('timeout');
        break;
      default:
        alert('unknown error');
        break;
    }
  }

  async start() {


    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // // this.startStageLat = position.coords.latitude;
          // // this.startStageLng = position.coords.longitude;
          const image = {
            // url: this.photoURL,
            size: new google.maps.Size(50, 50),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(25, 25),
            scaledSize: new google.maps.Size(50, 50)
          };

          const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          const marker = this.addMarker(latlng, image, 'You are here');
          marker.setMap(this.map);
          this.map.setCenter(latlng);

          const o = Object.assign({});
          o.time = new Date();
          o.position = position;
          this.UserCurrentLocationCompleteEvent.emit(o);

        }
        , this.error, { enableHighAccuracy: true, maximumAge: 60000, timeout: 6000 });
    } else {
      alert('geolocation not supported');
    }



  }


  loadSites() {

    return this.sitesService.findSitesByCompanyId(this.companyId).pipe(
      catchError(() => of([])),
      finalize(() => { })
    );
  }

  areYouHear(e: any) {

    // popup message are you here
    this.openUserSiteConfirmationDialog(e);

  }

  openUserSiteConfirmationDialog(e: any) {

    // const dialogRef = this.dialog.open(UserSiteConfirmationDialogueComponent, {
    //   width: 'auto',
    //   height: 'auto',
    //   data: {
    //     siteId: e.id,
    //     companyId: e.companyId,
    //     siteName: e.siteName,
    //     address: e.address,
    //     city: e.city,
    //     region: e.region,
    //     postalCode: e.postalCode,
    //     country: e.country
    //   }

    // });

    // dialogRef.afterClosed().subscribe(result => {

    //   if (result !== undefined) {

    //     const o = Object.assign({});
    //     o.time = new Date();
    //     o.data = result;
    //     this.UserSiteConfirmationCompleteEvent.emit(o);

    //   }


    // });
  }

}
